var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-visibility" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("mail_integration_detail.visibility"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("whatsapp_business_api.manageWhoChannelChat"))),
        ]),
      ]),
      _vm._v(" "),
      _c("VisibilityChanger", {
        attrs: { "show-title": false },
        model: {
          value: _vm.clone.visibility,
          callback: function ($$v) {
            _vm.$set(_vm.clone, "visibility", $$v)
          },
          expression: "clone.visibility",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }